import { render } from "./B2bPageAddServices.vue?vue&type=template&id=2244061c&scoped=true&lang=pug"
import script from "./B2bPageAddServices.vue?vue&type=script&lang=js"
export * from "./B2bPageAddServices.vue?vue&type=script&lang=js"

import "./B2bPageAddServices.vue?vue&type=style&index=0&id=2244061c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2244061c"]])

export default __exports__